import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'

export const pathKey = 'documentReportList' satisfies PathKey
